import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import moment from 'moment'
import datePicker from '../../component/dccore-form/datePicker.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'

if ($('#addon_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#addon_form',
    components: {
      RingLoader,
      datePicker,
      moment,
      TextInput,
      NumberInput,
      multimedia
    },
    mixins: [mixins],
    data: {
      loading: 0,
      multimedia: [],
      multimediaErrors: {},
      form: {
        entity: {
          availableFrom: moment().format('YYYY-MM-DD HH:mm'),
          availableTo: moment().format('YYYY-MM-DD HH:mm'),
          priceNet: null,
          vat: null,
          priceGross: null,
        },
        options: {
          errors: {},
        }
      },
      entityId: null,
    },
    watch:{
      'form.entity.priceGross' : function() {
        this.calcNetPrice()
      },
      'form.entity.vat' : function() {
        this.calcNetPrice()
      }
    },
    mounted() {
      this.loading++

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getAddon()
      }

      this.loading--
    },
    methods: {
      createAddon(redirect) {
        if (!this.$refs.errorChecker.errorCheck()) {
          let url = Routing.generate('api_post_addon')

          this.form.entity.availableFrom = moment(this.form.entity.availableFrom).format('YYYY-MM-DD HH:mm')
          this.form.entity.availableTo = moment(this.form.entity.availableTo).format('YYYY-MM-DD HH:mm')
          let data = {
            data: this.form.entity,
            multimedia: this.multimedia,
          }

          this.loading++
          this.$http.post(url, data).then(() => {
            if (redirect) {
              $(location).attr('href', Routing.generate('addon_grid'))
            } else {
              toastr.success(Translator.trans('form.created'))
              this.form.options.errors = {}
            }
            this.loading--

          }, response => {
            this.loading--
            this.handleAjaxError(response, this.form.options)
          })
        }
      },
      updateAddon(redirect) {
        if (!this.$refs.errorChecker.errorCheck()) {
          this.loading++
          let url = Routing.generate('api_patch_addon', {
            id: this.entityId,
          })
          this.form.entity.availableFrom = moment(this.form.entity.availableFrom).format('YYYY-MM-DD HH:mm')
          this.form.entity.availableTo = moment(this.form.entity.availableTo).format('YYYY-MM-DD HH:mm')

          let data = {
            data: this.form.entity,
            multimedia: this.multimedia
          }

          this.$http.patch(url, data).then(() => {
            if (redirect) {
              $(location).attr('href', Routing.generate('addon_grid'))
            } else {
              toastr.success(Translator.trans('form.updated'))
              this.form.options.errors = {}
            }
            this.loading--
          }, response => {
            this.loading--
            this.handleAjaxError(response, this.form.options)
          })
        }
      },
      getAddon() {
        this.loading++
        let url = Routing.generate('api_get_addon', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection

            delete this.form.entity.multimedia
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      calcNetPrice() {
        let gross = 0
        if (this.form.entity.priceGross) {
          gross = parseFloat(this.form.entity.priceGross)
        }
        let vat = 0
        if (this.form.entity.vat) {
          vat = parseFloat(this.form.entity.vat)
        }

        if (isNaN(gross)) {
          gross = 0
        }

        if (isNaN(vat)) {
          vat = 0
        }

        this.form.entity.priceGross = gross
        this.form.entity.vat = vat

        let net = 0

        if (vat === 0) {
          net = gross
        } else {
          if (gross !== 0 && vat !== 0) {
            net = gross / ((vat / 100) + 1)
          }
        }

        this.form.entity.priceNet = net.toFixed(2)
      },
    }
  })

}
